export default "__VITE_ASSET__B8hdYypf__"